import DefaultCell from "layouts/ecommerce/orders/order-list/components/DefaultCell";

//Icons
import TableChartIcon from '@mui/icons-material/TableChart';
import MapIcon from '@mui/icons-material/Map';
import ArticleIcon from '@mui/icons-material/Article';

import { IconButton } from "@mui/material";

const dataTableData = {
  columns: [
    {
      Header: "Dataset",
      accessor: "dataset",
      Cell: ({ value }) => {
        return value;
      },
    },
    {
      Header: "Time Period",
      accessor: "time",
      Cell: ({ value }) => {
        return <div style={{ textAlign: "center" }}>{value}</div>;
      },
    },
    {
      Header: "Geography",
      accessor: "geography",
      Cell: ({ value }) => {
        return <div style={{ textAlign: "center" }}>{value}</div>;
      },
    },
    {
      Header: "CSV",
      accessor: "csv",
      Cell: ({ value }) => {
        return <div style={{ textAlign: "center" }}>{value}</div>;
      },
    },
    {
      Header: "GeoJSON",
      accessor: "geojson",
      Cell: ({ value }) => {
        return <div style={{ textAlign: "center" }}>{value}</div>;
      },
    },
    { 
      Header: "Metadata", 
      accessor: "metadata", 
      Cell: ({ value }) => {
        return <div style={{ textAlign: "center" }}>{value}</div>;
      },
    },
  ],

  rows: [
    {
      dataset: "Solar Sentiment",
      time: "2013 - 2022",
      geography: "Cities",
      csv: (
        <a href="https://amplifysolar05c28e3aa82b7a41d9bef2b57aeb702074679c7-dev.s3.us-east-1.amazonaws.com/csv/Cities_2013-2022.csv" target="_blank" rel="noopener noreferrer">
          <IconButton>
            <TableChartIcon />
          </IconButton>
        </a>
      ),
      geojson: (
        <a href="https://amplifysolar05c28e3aa82b7a41d9bef2b57aeb702074679c7-dev.s3.us-east-1.amazonaws.com/json/Cities_GeoJSON.zip" target="_blank" rel="noopener noreferrer">
          <IconButton>
            <MapIcon />
          </IconButton>
        </a>
      ),
      metadata: (
        <a href="https://amplifysolar05c28e3aa82b7a41d9bef2b57aeb702074679c7-dev.s3.us-east-1.amazonaws.com/metadata/Cities_Metadata.csv" target="_blank" rel="noopener noreferrer">
          <IconButton>
            <ArticleIcon />
          </IconButton>
        </a>
      ),
    },
    {
      dataset: "Solar Sentiment",
      time: "2013 - 2022",
      geography: "States",
      csv: (
        <a href="https://amplifysolar05c28e3aa82b7a41d9bef2b57aeb702074679c7-dev.s3.us-east-1.amazonaws.com/csv/States_2013-2022.csv" target="_blank" rel="noopener noreferrer">
          <IconButton>
            <TableChartIcon />
          </IconButton>
        </a>
      ),
      geojson: (
        <a href="https://amplifysolar05c28e3aa82b7a41d9bef2b57aeb702074679c7-dev.s3.us-east-1.amazonaws.com/json/States_GeoJSON.zip" target="_blank" rel="noopener noreferrer">
          <IconButton>
            <MapIcon />
          </IconButton>
        </a>
      ),
      metadata: (
        <a href="https://amplifysolar05c28e3aa82b7a41d9bef2b57aeb702074679c7-dev.s3.us-east-1.amazonaws.com/metadata/States_Metadata.csv" target="_blank" rel="noopener noreferrer">
          <IconButton>
            <ArticleIcon />
          </IconButton>
        </a>
      ),
    },
  ],
};

export default dataTableData;
